import { useI18n } from "@wojo/localization";
import { TaskLabel } from "@wojo/ui";
import cn from "clsx";
import styles from "./ChecklistTaskLabel.module.scss";

export type ChecklistTaskLabelProps = {
    required: number;
    recommended: number;
    showAllLevels?: boolean;
};
export const ChecklistTaskLabel: React.FC<ChecklistTaskLabelProps> = ({
    required,
    recommended,
    showAllLevels,
}) => {
    const l10n = useI18n("account").account.checklist;
    if (required === 0 && recommended === 0) {
        return null;
    }
    const showRecommended = showAllLevels || required === 0;

    return (
        <>
            {required > 0 && (
                <>
                    <TaskLabel
                        status="alert"
                        text={l10n.required.l({ count: required.toString() })}
                        className={cn({
                            [styles["checklist-task-label-spacing"]]:
                                showRecommended,
                        })}
                    />
                    <span className="visually-hidden">
                        {` ${l10n.tasks.l()}`}
                    </span>
                </>
            )}
            {showRecommended && recommended > 0 && (
                <>
                    <TaskLabel
                        status="alert"
                        variant="secondary"
                        text={l10n.recommended.l({
                            count: recommended.toString(),
                        })}
                    />
                    <span className="visually-hidden">
                        {` ${l10n.tasks.l()}`}
                    </span>
                </>
            )}
        </>
    );
};
